import React from 'react';
import { ChevronDown, Plus, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface CreateImageDropdownProps {
  isOpen: boolean;
  isGenerating: boolean;
  isCanvaLoading: boolean;
  onToggle: () => void;
  onGenerate: () => void;
  onCanva: () => void;
  canvaLogo: string;
}

export const CreateImageDropdown: React.FC<CreateImageDropdownProps> = ({
  isOpen,
  isGenerating,
  isCanvaLoading,
  onToggle,
  onGenerate,
  onCanva,
  canvaLogo,
}) => {
  const { t } = useTranslation();
  return (
    <div className="relative">
      <button
        onClick={onToggle}
        disabled={isCanvaLoading || isGenerating}
        className="inline-flex items-center px-3 py-1.5 text-sm font-semibold text-white bg-primary-600 hover:bg-primary-700 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Plus className="w-4 h-4 mr-1.5" />
        {t('actions.createImage', 'Create an image')}
        <ChevronDown className={`w-4 h-4 ml-1.5 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute top-full mt-1 right-0 z-10 w-56 bg-white border border-gray-200 rounded-lg shadow-lg">
          <div className="py-1">
            <button
              onClick={onGenerate}
              disabled={isGenerating}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isGenerating ? (
                <>
                  <div className="w-4 h-4 mr-3 border-2 border-t-transparent border-gray-500 rounded-full animate-spin"></div>
                  {t('common.generating', 'Generating...')}
                </>
              ) : (
                <>
                  <Sparkles className="w-4 h-4 mr-3 text-purple-500" />
                  {t('actions.generateWithAI', 'Generate with AI')}
                </>
              )}
            </button>
            <button
              onClick={onCanva}
              disabled={isCanvaLoading}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isCanvaLoading ? (
                <>
                  <div className="w-4 h-4 mr-3 border-2 border-t-transparent border-gray-500 rounded-full animate-spin"></div>
                  {t('common.loading', 'Loading...')}
                </>
              ) : (
                <>
                  <img src={canvaLogo} alt="Canva" className="w-4 h-4 mr-3" />
                  <span className="flex items-center">
                    {t('actions.designInCanva', 'Design in Canva')}
                    <span className="ml-2 inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-red-500 text-white">Beta</span>
                  </span>
                </>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};


